import React from "react";
import Seo from "../components/common/Seo";

const CookiePolicy = () => {
  return (
    <>
      <Seo
        title="Política de Cookies"
        description="Política de cookies de TransXSur. Información sobre el uso de cookies en nuestro sitio web."
        url="https://www.transxsur.com/politica-cookies"
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-display font-bold mb-8 text-[#1e5939]">
          Política de Cookies
        </h1>
        <div className="prose max-w-none text-gray-700 space-y-6">
          <p>
            En TransXSur utilizamos cookies propias y de terceros para mejorar
            tu experiencia de navegación y analizar el tráfico de nuestra web. A
            continuación, te explicamos qué son, qué tipos utilizamos y cómo
            puedes configurarlas.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            1. ¿Qué son las cookies?
          </h2>
          <p>
            Las cookies son pequeños archivos de texto que se almacenan en tu
            dispositivo (ordenador, tablet, móvil) cuando visitas una página
            web. Permiten a la web recordar tus acciones y preferencias (como
            idioma, tamaño de letra, etc.) durante un tiempo, para que no tengas
            que volver a configurarlas cada vez que nos visites.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            2. Tipos de cookies que utilizamos
          </h2>
          <ul className="list-disc pl-6">
            <li>
              <strong>Cookies técnicas (necesarias):</strong> Son
              imprescindibles para el funcionamiento básico de la web (por
              ejemplo, las de sesión o seguridad). No requieren consentimiento
              del usuario.
            </li>
            <li>
              <strong>Cookies analíticas (terceros):</strong> Utilizamos Google
              Analytics para contar visitas y fuentes de tráfico, lo que nos
              permite medir y mejorar el rendimiento de nuestro sitio. Estas
              cookies son de terceros y solo se activan si aceptas el banner de
              cookies. Puedes consultar la política de privacidad de Google
              Analytics en:{" "}
              <a
                href="https://policies.google.com/technologies/cookies"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#44aa56] hover:underline"
              >
                https://policies.google.com/technologies/cookies
              </a>
              .
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            3. Cómo gestionar las cookies
          </h2>
          <p>
            Puedes permitir, bloquear o eliminar las cookies instaladas en tu
            dispositivo mediante la configuración de tu navegador. A
            continuación, te indicamos enlaces con instrucciones para los
            navegadores más comunes:
          </p>
          <ul className="list-disc pl-6">
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#44aa56] hover:underline"
              >
                Google Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#44aa56] hover:underline"
              >
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#44aa56] hover:underline"
              >
                Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#44aa56] hover:underline"
              >
                Microsoft Edge
              </a>
            </li>
          </ul>
          <p>
            También puedes optar por no ser rastreado por Google Analytics en
            todos los sitios web instalando el complemento de inhabilitación:{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#44aa56] hover:underline"
            >
              https://tools.google.com/dlpage/gaoptout
            </a>
            .
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            4. Cambios en la política de cookies
          </h2>
          <p>
            Podemos actualizar esta política de cookies en función de cambios
            normativos o de los propios servicios. Te recomendamos revisarla
            periódicamente.
          </p>

          <p className="text-sm text-gray-500 border-t pt-4 mt-6">
            Última actualización: febrero de 2026.
          </p>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;
